import { styled } from 'styled-components';

import { colors, fontWeights } from 'theme/theme';

export const DetailListSectionHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: ${colors.darkContentGrey};
`;

export const DetailListSectionTitle = styled.h5`
  margin: 0;
  font-size: 16px;
  font-weight: ${fontWeights.semiBold};
`;
